import styled from "styled-components";
import VLButton from "./VLButton";

const AdjustingButton = styled(VLButton)`
  height: auto;
  padding: 0;
`;

export default AdjustingButton;
